import { EnumSchema } from '../metadata-schema';

export const DoorstroomResultaatMetPrognose: EnumSchema = {
	"type": "string",
	"title": "DoorstroomResultaatMetPrognose",
	"enum": [
		"Doorstroom",
		"Doorstroom (prognose)",
		"Geslaagd",
		"Geslaagd (prognose)",
		"Opstroom",
		"Opstroom (prognose)",
		"Afstroom",
		"Afstroom (prognose)",
		"Doublure",
		"Doublure (prognose)",
		"Afgewezen",
		"Afgewezen (prognose)",
		"VO verlater",
		"Geen"
	]
};
